import { useMantineColorScheme } from '@mantine/core';
import { useEffect } from 'react';

import { ColorTheme } from '@/models/color-theme.ts';

import { useAuthStore } from '@/stores/auth-store.ts';
import { useThemeStore } from '@/stores/theme-store.ts';

export const useTheme = (): void => {
    const { colorScheme, setColorScheme } = useMantineColorScheme();
    const isUserSet = useAuthStore((state) => state.isUserSet);
    const isAdmin = useAuthStore((state) => state.isAdmin);

    // Set theme to dark by default for admin
    useEffect(() => {
        if (!isUserSet || !isAdmin) return;
        const savedTheme: string | null = localStorage.getItem('mantine-color-scheme-value');
        if (!savedTheme) setColorScheme('dark');
    }, [isUserSet, isAdmin, setColorScheme]);

    useEffect(() => {
        useThemeStore.setState({ theme: colorScheme as ColorTheme });
    }, [colorScheme]);
};
